import {
  axiosInstance,
  GET_ACTIVE_RECALL_URL,
  ACTIVE_RECALL_COMPLETED_URL,
  GET_ACTIVE_RECALL_COMPLETED_URL,
} from "../apiurls/apiurls";

export const getActiveRecallTopics = async () => {
  const response = await axiosInstance.get(GET_ACTIVE_RECALL_URL);

  const rawItems = Array.isArray(response.data)
    ? response.data
    : Array.isArray(response.data?.data)
      ? response.data.data
      : [];

  const activeItems = rawItems.filter((item) => item && item.is_active);

  return activeItems.map((item, index) => {
    const { current_name, is_active, name, path, title } = item || {};

    const breadcrumb = name ? name.split("/").join(" > ") : "";

    return {
      id: path || index,
      title: current_name || title || name || "Untitled",
      breadcrumb,
      status: is_active ? "active" : "inactive",
      link: path || "",
      completed: item.completed || false,
    };
  });
};

export const submitActiveRecallCompleted = async (params, data = {}) => {
  try {
    const response = await axiosInstance.post(
      ACTIVE_RECALL_COMPLETED_URL,
      data,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting active recall completion:", error);
    throw error;
  }
};

export const getActiveRecallCompletedApi = async (params) => {
  try {
    const response = await axiosInstance.get(GET_ACTIVE_RECALL_COMPLETED_URL, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active recall completed:", error);
    throw error;
  }
};
